import '../components/auth/auth';

export const data = {
  auth: {
    isAuth: false,
    accessToken: '',
  },
  user: {
    adv: [],
    favourites: [],
    email: '',
    id: '',
    registrationDate: '',
  },
  calls: {
    ads: [],
    categories: [],
    allCategories: [],
    russianCategories: [],
    specificCategory: {},
    originalCategories: [],
  },
  renderedCategories: [],
};
